import * as tslib_1 from "tslib";
import m from 'mithril';
import { Image, ImageResizer } from '../ui/image';
import { View } from '../ui/view';
import { classes } from '../util/classes';
import { getResizedUrl } from './picture';
var Background = /** @class */ (function (_super) {
    tslib_1.__extends(Background, _super);
    function Background() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Background.prototype.render = function () {
        var _a = this.attrs, children = _a.children, img = _a.img, className = _a.class, rest = tslib_1.__rest(_a, ["children", "img", "class"]);
        if (img && typeof img == 'object' && img.empty)
            return;
        var src = typeof img === 'string' ? img : img.src;
        var position = (typeof img == 'object' && img.focus) || 'center center';
        return m(ImageResizer, {
            resize: function (attrs, container) {
                var src = attrs.src;
                if (src.indexOf('://') > -1)
                    return attrs;
                var url = getResizedUrl(src, container.width, container.height);
                return tslib_1.__assign({}, attrs, { src: url });
            }
        }, m(Image, tslib_1.__assign({ src: src, background: true, fit: 'cover', position: position, upScale: true }, classes('background', className), rest), children));
    };
    return Background;
}(View));
export { Background };
